import { message } from 'antd';
import { getExchangeUrl } from '@/utils/location';

const DEFAULT_KEY = 'default';

const normalizeMediaKey = (key?: string): string => {
  const normalized = (key || '').trim().toLowerCase();
  if (!normalized) {
    return DEFAULT_KEY;
  }
  if (normalized === 'zh-hk' || normalized === 'zh_tw' || normalized === 'zh-tw' || normalized === 'hk') {
    return 'hk';
  }
  return normalized;
};

const normalizeMediaType = (type?: string): string => {
  return (type || '').trim().toLowerCase();
};

const requestMediaUrl = async (type: string, key?: string): Promise<string> => {
  const response = await fetch(
    `${getExchangeUrl().media}?type=${encodeURIComponent(normalizeMediaType(type))}&key=${encodeURIComponent(normalizeMediaKey(key))}`,
    {
      credentials: 'include',
    },
  );
  const result = await response.json();
  if (!response.ok || result?.code !== 0) {
    throw new Error(result?.msg || '链接暂不可用');
  }
  const url = result?.data;
  return typeof url === 'string' ? url.trim() : '';
};

export const openMediaUrl = async (type: string, key?: string, emptyMessage = '开发中，敬请期待') => {
  try {
    const url = await requestMediaUrl(type, key);
    if (!url) {
      message.success(emptyMessage);
      return;
    }
    const popup = window.open(url, '_blank', 'noopener,noreferrer');
    if (popup) {
      popup.opener = null;
    }
  } catch (error) {
    message.error(emptyMessage);
  }
};

export const openTelegramUrl = async (key?: string) => {
  await openMediaUrl('telegram', key, 'Telegram链接暂不可用');
};
